document.addEventListener("DOMContentLoaded", function () {
  const grid = document.getElementById("cocktails-grid"),
    cards = grid.querySelectorAll(".cocktail-card"),
    filterGroups = document.querySelectorAll(".cocktail-filter-group"),
    resetBtn = document.getElementById("reset-filters"),
    activeFiltersContainer = document.getElementById("active-filters"),
    activeFiltersTags = document.getElementById("active-filters-tags"),
    resultsCount = document.getElementById("visible-count"),
    noResults = document.getElementById("no-results"),
    searchInput = document.getElementById("cocktail-search-input"),
    filtersPanel = document.querySelector('.cocktail-filters-panel');
    filtersToggle = document.querySelectorAll('.cocktail-filters-toggle, .cocktail-filters-close');
  let activeFilters = { spirit: [], brand: [], flavor: [], difficulty: [] },
    searchQuery = "";
  const filterLabels = {
    spirit: {},
    flavor: {},
    difficulty: { facile: "Facile", moyen: "Moyen", difficile: "Difficile" },
    brand: {},
  };
  function extractFromData(attr) {
    const items = new Set();
    cards.forEach((c) => {
      const d = c.dataset[attr];
      if (d)
        d.split(",").forEach((x) => {
          if (x.trim()) items.add(x.trim());
        });
    });
    return Array.from(items).sort();
  }
  function populateDynamicFilter(containerId, filterName, dataAttr) {
    const opts = document.getElementById(containerId),
      items = extractFromData(dataAttr);
    if (!items.length) {
      opts.innerHTML = '<p class="cocktail-filter-loading">Aucun élément</p>';
      return;
    }
    opts.innerHTML = items
      .map((item) => {
        const l = item
          .split("-")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
          .join(" ");
        filterLabels[filterName][item] = l;
        return `<label class="cocktail-filter-option"><input type="checkbox" name="${filterName}" value="${item}"><span class="cocktail-filter-checkbox"></span><span>${l}</span></label>`;
      })
      .join("");
    opts
      .querySelectorAll('input[type="checkbox"]')
      .forEach((cb) => cb.addEventListener("change", handleFilterChange));
  }
  filterGroups.forEach((g) => {
    const t = g.querySelector(".cocktail-filter-toggle"),
      d = g.querySelector(".cocktail-filter-dropdown");
    t.addEventListener("click", (e) => {
      e.stopPropagation();
      const exp = t.getAttribute("aria-expanded") === "true";
      filterGroups.forEach((x) => {
        x.querySelector(".cocktail-filter-toggle").setAttribute(
          "aria-expanded",
          "false"
        );
        x.querySelector(".cocktail-filter-dropdown").hidden = true;
      });
      if (!exp) {
        t.setAttribute("aria-expanded", "true");
        d.hidden = false;
      }
    });
  });
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".cocktail-filter-group"))
      filterGroups.forEach((g) => {
        g.querySelector(".cocktail-filter-toggle").setAttribute(
          "aria-expanded",
          "false"
        );
        g.querySelector(".cocktail-filter-dropdown").hidden = true;
      });
    if (!e.target.closest(".cocktail-filters-panel") && !e.target.closest(".cocktail-filters-toggle")) {
      document.querySelector('.cocktail-filters-panel').hidden = true;
    }
  });
  function handleFilterChange(e) {
    const cb = e.target,
      fg = cb.name,
      v = cb.value;
    if (cb.checked) {
      if (!activeFilters[fg].includes(v)) activeFilters[fg].push(v);
    } else {
      activeFilters[fg] = activeFilters[fg].filter((x) => x !== v);
    }
    applyFilters();
    updateUI();
  }
  document
    .querySelectorAll('.cocktail-filter-option input[type="checkbox"]')
    .forEach((cb) => cb.addEventListener("change", handleFilterChange));
  const toggleFiltersPanel = () => {
    filtersPanel.hidden = !filtersPanel.hidden;
  }
  if (searchInput)
    searchInput.addEventListener("input", (e) => {
      searchQuery = e.target.value.toLowerCase().trim();
      applyFilters();
    });
  function applyFilters() {
    let count = 0;
    cards.forEach((c) => {
      let m = true;
      if (searchQuery && !(c.dataset.title || "").includes(searchQuery))
        m = false;
      if (m && activeFilters.spirit.length) {
        const cs = (c.dataset.spirits || "").split(",");
        if (!activeFilters.spirit.some((s) => cs.includes(s))) m = false;
      }
      if (
        m &&
        activeFilters.difficulty.length &&
        !activeFilters.difficulty.includes(c.dataset.difficulty)
      )
        m = false;
      if (m && activeFilters.flavor.length) {
        const cf = (c.dataset.flavors || "").split(",");
        if (!activeFilters.flavor.some((f) => cf.includes(f))) m = false;
      }
      if (m && activeFilters.brand.length) {
        const cb = (c.dataset.brands || "").split(",");
        if (!activeFilters.brand.some((b) => cb.includes(b))) m = false;
      }
      c.hidden = !m;
      if (m) count++;
    });
    resultsCount.textContent = count;
    noResults.hidden = count > 0;
    grid.hidden = count === 0;
  }
  function updateUI() {
    filterGroups.forEach((g) => {
      const fg = g.dataset.filterGroup,
        cnt = activeFilters[fg].length,
        el = g.querySelector(".cocktail-filter-toggle__count");
      el.dataset.count = cnt;
      el.textContent = cnt;
    });
    const hasActive = Object.values(activeFilters).some((a) => a.length > 0);
    resetBtn.disable = !hasActive;
    activeFiltersContainer.hidden = !hasActive;
    activeFiltersTags.innerHTML = "";
    Object.entries(activeFilters).forEach(([g, vals]) => {
      vals.forEach((v) => {
        const lbl = filterLabels[g][v] || v,
          tag = document.createElement("button");
        tag.className = "cocktail-active-filter-tag";
        tag.innerHTML = `${lbl}<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>`;
        tag.addEventListener("click", () => {
          const cb = document.querySelector(`input[name="${g}"][value="${v}"]`);
          if (cb) cb.checked = false;
          activeFilters[g] = activeFilters[g].filter((x) => x !== v);
          applyFilters();
          updateUI();
        });
        activeFiltersTags.appendChild(tag);
      });
    });
  }
  function resetAll() {
    Object.keys(activeFilters).forEach((g) => (activeFilters[g] = []));
    document
      .querySelectorAll('.cocktail-filter-option input[type="checkbox"]')
      .forEach((cb) => (cb.checked = false));
    if (searchInput) searchInput.value = "";
    searchQuery = "";
    applyFilters();
    updateUI();
  }
  filtersToggle.forEach(toggleButton => {
    toggleButton.addEventListener('click', toggleFiltersPanel);
  })
  resetBtn.addEventListener("click", resetAll);
  const nrReset = document.querySelector(".cocktail-no-results__reset");
  if (nrReset) nrReset.addEventListener("click", resetAll);
  populateDynamicFilter("spirit-filter-options", "spirit", "spirits");
  populateDynamicFilter("brand-filter-options", "brand", "brands");
  populateDynamicFilter("flavor-filter-options", "flavor", "flavors");
  updateUI();
});
